import { isClub, isSoloare } from "../models/js_env";
import { Env } from "../env";

// ログイン画面（CLUB）
const LOGIN_URL_CLUB = Env.SETTING.clubFront.urlBase + 'webapp/shops-club/servlet/YLogonSSLView';
// ログイン画面（SOLOARE）
const LOGIN_URL_SOLOARE = Env.SETTING.soloareFront.urlBase + 'buyer/view/a010/DAA01010.html';

const enableRedirectSelect = (selector = 'select', optionAttribute = 'data-redirect-url') => {
  document.querySelectorAll(selector).forEach((select: Element) => {
    select.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLSelectElement;
      const selectedOption = target.options[target.selectedIndex];

      const redirectURL = selectedOption.getAttribute(optionAttribute);
      if (redirectURL) {
        window.location.href = redirectURL;
      }
    });
  });
};

const toLoginPage = (
  redirectUrlClub?: string,
  redirectUrlSoloel?: string,
) => {
  if (isClub(Env.SITE_TYPE)) {
    const encodeClubUri = encodeURIComponent(redirectUrlClub ?? location.pathname);
    window.location.href = LOGIN_URL_CLUB + '?transitionURL=' + encodeClubUri;
  } else if (isSoloare(Env.SITE_TYPE)) {
    const encodeSoloareUri = encodeURIComponent(redirectUrlSoloel ?? location.pathname);
    window.location.href = LOGIN_URL_SOLOARE + '?directUrl=' + encodeSoloareUri;
  } else {
    // TODO TRYLION(R2以降)
    window.location.href = '';
  }
}

const RedirectUtil = {
  enableRedirectSelect,
  toLoginPage,
};

export default RedirectUtil;
